"use client";

import { useEffect } from "react";
/* eslint-disable react-hooks/exhaustive-deps */
import { useAnalytics } from "@/components/analytics/initialise-analytics";
import { StockPriceMappedProduct } from "@/utils/map-product-data";
import {
  getTotalUniqueSizes,
  getTotalInStock,
  getVariantStockStatus,
  mapVariants,
} from "./analytics-helpers";

export type ViewProductAnalyticsProps = {
  mappedFullProductData: StockPriceMappedProduct;
};

export const ViewProductAnalytics = ({
  mappedFullProductData,
}: ViewProductAnalyticsProps) => {
  const { pushToDataLayer } = useAnalytics();

  useEffect(() => {
    const { href } = window.location;

    pushToDataLayer({
      view_item: {
        productId: mappedFullProductData.id,
        productCode: mappedFullProductData.productCode,
        availableSku: getTotalInStock(mappedFullProductData),
        availableSizes: getTotalUniqueSizes({
          variants: mappedFullProductData.variants,
        }),
        productUrl: href,
        cid: mappedFullProductData.productType?.id,
        category: mappedFullProductData.productType?.name,
        variantStockStatus: getVariantStockStatus(mappedFullProductData),
        ecommerce: {
          currency: "GBP",
          localCurrencyCode: mappedFullProductData.productPrice.currency,
          valueLocalCurrency:
            mappedFullProductData?.variants[0]?.price.current.value,
          value: mappedFullProductData?.variants[0]?.price.xrp?.value,
          items: mapVariants(mappedFullProductData),
        },
      },
    });
  }, [mappedFullProductData]);

  return null;
};
